import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import FormInputField from 'components/Shared/FormInputField';
import FormControlCheckbox from 'components/Shared/FormControlCheckbox';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import Link from '@material-ui/core/Link';
import CircularProgress from '@material-ui/core/CircularProgress';

// import { ReactComponent as GoogleIcon } from 'assets/google.svg';

const LoginFormView = ({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
    loginLoading,
    ssoLoginLoading,
    // handleSSOLogin,
}) => {
    const isEmailRequirementNotMet = errors.email && touched.email;
    const isPasswordRequirementNotMet = errors.password && touched.password;
    const isRememberMeChecked = values.rememberMe;
    const hasRememberMeError = errors.rememberMe;
    const isRememberMeFieldTouched = touched.rememberMe;

    return (
        <form autoComplete="off">
            <FormInputField
                className="smaller"
                withInputLabel
                label="Email"
                placeholder="Enter your email address here"
                name="email"
                value={values.email}
                showValidationRequirement={isEmailRequirementNotMet}
                requirementText={errors.email}
                isRequirementNotMet={isEmailRequirementNotMet}
                handleChange={handleChange}
                handleBlur={handleBlur}
            />

            <FormInputField
                className="smaller"
                withPasswordVisibility
                withInputLabel
                label="Password"
                placeholder="Enter your password here"
                name="password"
                value={values.password}
                showValidationRequirement={isPasswordRequirementNotMet}
                requirementText={errors.password}
                isRequirementNotMet={isPasswordRequirementNotMet}
                handleChange={handleChange}
                handleBlur={handleBlur}
            />

            <div className="form-fields-wrapper">
                <FormControlCheckbox
                    className="smaller"
                    isTouched={isRememberMeFieldTouched}
                    hasError={hasRememberMeError}
                    name="rememberMe"
                    label="Remember me"
                    checked={isRememberMeChecked}
                    handleChange={() => setFieldValue('rememberMe', !isRememberMeChecked)}
                />

                <Link className="forgotten-pwd-link" component={RouterLink} to="/forgottenpassword">
                    Forgot Password
                </Link>
            </div>

            <div className="buttons-wrapper">
                <ActionButton
                    text={(!loginLoading && ssoLoginLoading) ? <CircularProgress className="white" /> : "Log In"}
                    handleClick={handleSubmit}
                />

                {/* <ActionButton
                    className="inverted with-icon"
                    text={ssoLoginLoading ? "Log In with Google" : <CircularProgress className="teal" />}
                    icon={ssoLoginLoading && <GoogleIcon />}
                    handleClick={handleSSOLogin}
                /> */}
            </div>
            {/* <div className="sign-text-wrapper">Don't have an account? <Link component={RouterLink} to="/register/agency">Sign Up here.</Link></div> */}
        </form>
    )
};

export default LoginFormView;
